"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var baseConfigAip = _interopRequireWildcard(require("@/api/baseConfig.js"));
var _validate = require("@/utils/validate");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
var _default = exports.default = {
  name: 'proportionalAllocationEdit',
  props: {
    isCreate: {
      type: Number,
      required: true
    },
    editData: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      chooseMerchantVisible: false,
      pram: {
        debtDeductionRatios: [],
        debtResolutionRatios: [],
        cashbackRatios: [],
        couponCashbackRatios: [],
        memberCards: [],
        id: undefined
      },
      selectValue: '',
      menuExpand: false,
      menuNodeAll: false,
      memberCardsidMap: {},
      memberCards: [],
      defaultProps: {
        children: 'childList',
        label: 'name'
      },
      menuIds: []
    };
  },
  mounted: function mounted() {
    this.initEditData();
    this.getcardList();
  },
  methods: {
    getcardList: function getcardList() {
      var _this = this;
      baseConfigAip.getcardList().then(function (res) {
        console.log(res);
        _this.memberCardsidMap = Object.fromEntries(res.map(function (item) {
          return [item.id, item];
        }));
        _this.memberCards = res;
      });
    },
    addorReduce: function addorReduce(data, index) {
      if (index !== undefined) {
        if (data.length === 1) {
          this.$message('最少添加1个');
          return false;
        }
        data.splice(index, 1);
      } else {
        if (data.length > 5) {
          this.$message('最多添加6个');
          return false;
        }
        data.push('');
      }
    },
    close: function close() {
      this.$emit('hideEditDialog');
    },
    initEditData: function initEditData() {
      var _this2 = this;
      if (this.isCreate === 0) return;
      var _this$editData = this.editData,
        id = _this$editData.id,
        merchantName = _this$editData.merchantName;
      if (!id) return;
      var loading = this.$loading({
        lock: true,
        text: 'Loading'
      });
      baseConfigAip.gettranchingListDetail(id).then(function (res) {
        console.log(res);
        _this2.pram = res;
        loading.close();
      });
    },
    removeRow: function removeRow(index) {
      this.pram.memberCards.splice(index, 1);
    },
    togglehideDialog: function togglehideDialog() {
      this.chooseMerchantVisible = !this.chooseMerchantVisible;
    },
    handlerSubmit: function handlerSubmit() {
      var _this3 = this;
      var id = this.editData.id;
      var loading = this.$loading({
        lock: true,
        text: 'Loading'
      });
      if (id) {
        baseConfigAip.updateTranching(_objectSpread({}, this.pram)).then(function (res) {
          _this3.$message.success('修改成功');
          _this3.close();
        });
      } else {
        baseConfigAip.addTranching(_objectSpread({}, this.pram)).then(function (res) {
          _this3.$message.success('添加成功');
          _this3.close();
        });
      }
      loading.close();
    },
    handleChange: function handleChange(value, index) {
      console.log(value, index);
      if (this.pram.memberCards.filter(function (item) {
        return item.id === value;
      }).length === 0) {
        this.pram.memberCards.push(this.memberCardsidMap[value]);
      }
    }
  }
};